import axios, { AxiosResponse, CancelTokenSource } from "axios"
import { InsertFacturaProformaCommandProps } from "./Commands/InsertFacturaProformaCommand"
import { GetFacturaProformaByIdDtoProps } from "./DTOs/GetFacturaProformaByIdDto"
import { GetFacturaProformaDetalleByIdDtoProps } from "./DTOs/GetFacturaProformaDetalleByIdDto"
import {
  getFacturaProformaAdapter,
  getFacturaProformaByIdAdapter,
  getFacturaProformaDetalleByIdAdapter,
} from "./FacturaProforma.adapter"
import { GetFacturasProformaByFiltersDtoIPagedEnumerable } from "./Schemas/GetFacturasProformaByFiltersDtoIPagedEnumerable"
import { SortingCriteria } from "./interfaces/SortingCriteria"

export interface FacturaProformaQueryParamsProps {
  FechaEmisionLowerLimit?: string
  FechaEmisionUpperLimit?: string
  ImporteLowerLimit?: number
  ImporteUpperLimit?: number
  Keyword?: string
  SortingCriteria?: SortingCriteria
  IsEnabled?: boolean
  MaxResultCount?: number
  SkipCount?: number
}

// eslint-disable-next-line import/no-mutable-exports
export let facturasProformaByFiltersCall: CancelTokenSource
/**
 * Retrieves a factura proforma by applying optional query parameters.
 * @param queryParams - Optional query parameters to filter the results.
 * @returns A promise that resolves to a paged enumerable of `GetFacturasProformaByFiltersDtoIPagedEnumerable`.
 */
export async function getFacturaProforma(
  queryParams?: FacturaProformaQueryParamsProps
): Promise<GetFacturasProformaByFiltersDtoIPagedEnumerable> {
  if (typeof facturasProformaByFiltersCall !== typeof undefined) {
    facturasProformaByFiltersCall.cancel("Previous Request Cancelled")
  }
  facturasProformaByFiltersCall = axios.CancelToken.source()
  const { data }: { data: GetFacturasProformaByFiltersDtoIPagedEnumerable } =
    await axios.get("/FacturaProforma", {
      params: queryParams,
      cancelToken: facturasProformaByFiltersCall.token,
    })
  return {
    currentPage: data?.currentPage,
    items: data?.items?.map((item) => getFacturaProformaAdapter(item)),
    totalCount: data?.totalCount,
  }
}

export async function getFacturaProformaById(
  id: string
): Promise<GetFacturaProformaByIdDtoProps> {
  const { data }: { data: GetFacturaProformaByIdDtoProps } = await axios.get(
    `/FacturaProforma/${id}`
  )
  return getFacturaProformaByIdAdapter(data)
}

export async function getFacturaProformaDetalleById(
  id: string
): Promise<GetFacturaProformaDetalleByIdDtoProps> {
  const { data }: { data: GetFacturaProformaDetalleByIdDtoProps } =
    await axios.get(`/FacturaProforma/${id}/detalle`)
  return getFacturaProformaDetalleByIdAdapter(data)
}

export async function postFacturaProforma(
  requestBody: InsertFacturaProformaCommandProps
): Promise<AxiosResponse> {
  const resp = await axios.post("/FacturaProforma", requestBody)
  return resp
}

export async function deleteFacturaProformaById(
  id: string
): Promise<AxiosResponse> {
  const resp = await axios.delete(`/FacturaProforma/${id}`)
  return resp
}
